import React, { useMemo } from 'react';
import { Box } from '@mui/material';
import { buildDocumentPreviewHtml } from '../../../Utils/DocumentVersion/documentPreviewHtml';
import styles from './DocumentSettingsDialog.module.scss';

const DocumentPreview = ({ 
    t,
    client, 
    settings, 
    selectedDocumentType, 
    signaturePreview, 
    profilePreview,
    direction,
    defaultItem = null
}) => {
    const generatePreviewHtml = useMemo(
        () => buildDocumentPreviewHtml({
            client,
            settings,
            selectedDocumentType,
            signaturePreview,
            profilePreview,
            direction,
            defaultItem,
        }),
        [client, settings, selectedDocumentType, signaturePreview, profilePreview, defaultItem, direction]
    );
    
    return (
        <Box className={styles.previewFrame} dir={direction}>
            {generatePreviewHtml ? (
                <Box className={styles.previewCanvas}>
                    <Box className={styles.previewPage}>
                        <iframe
                            srcDoc={generatePreviewHtml}
                            style={{
                                width: '100%',
                                height: '100%',
                                border: 'none',
                                minHeight: '297mm'
                            }}
                            title="Document Preview"
                        />
                    </Box>
                </Box>
            ) : (
                <Box className={styles.previewEmpty} dir={direction}>
                    {t('GeneratingPreview') || 'טוען תצוגה מקדימה...'}
                </Box>
            )}
        </Box>
    );
};

export default DocumentPreview;
